import { render, staticRenderFns } from "./menus.vue?vue&type=template&id=1d5ec914&scoped=true"
import script from "./menus.vue?vue&type=script&lang=js"
export * from "./menus.vue?vue&type=script&lang=js"
import style0 from "./menus.vue?vue&type=style&index=0&id=1d5ec914&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5ec914",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d5ec914')) {
      api.createRecord('1d5ec914', component.options)
    } else {
      api.reload('1d5ec914', component.options)
    }
    module.hot.accept("./menus.vue?vue&type=template&id=1d5ec914&scoped=true", function () {
      api.rerender('1d5ec914', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/menus.vue"
export default component.exports